import React from "react"
import { CommonButton, CommonButtonProps } from "./common-button"
import { ButtonTypeEnum, ButtonSizeEnum } from "./enums"

interface ButtonWithTypeProps extends Omit<CommonButtonProps, "type" | "icon"> {
  children: React.ReactNode
}

export const PrimaryButton = ({ ...props }: ButtonWithTypeProps) => (
  <CommonButton
    type={ButtonTypeEnum.Primary}
    size={ButtonSizeEnum.Medium}
    {...props}
  />
)

export const SecondaryButton = ({ ...props }: ButtonWithTypeProps) => (
  <CommonButton
    type={ButtonTypeEnum.Secondary}
    size={ButtonSizeEnum.Medium}
    {...props}
  />
)

export const TertiaryButton = ({ ...props }: ButtonWithTypeProps) => (
  <CommonButton
    type={ButtonTypeEnum.Tertiary}
    size={ButtonSizeEnum.Medium}
    {...props}
  />
)

export const GhostButton = ({ ...props }: ButtonWithTypeProps) => (
  <CommonButton
    type={ButtonTypeEnum.Ghost}
    size={ButtonSizeEnum.Small}
    {...props}
  />
)

export const TextButton = ({ ...props }: ButtonWithTypeProps) => (
  <CommonButton
    type={ButtonTypeEnum.Text}
    size={ButtonSizeEnum.Small}
    {...props}
  />
)
